import React, { useEffect, useRef, useState } from 'react';
import './ChipSelect.css';

const ChipSelect = ({ options = [], value = [], onChange, placeholder = 'Selecteaza...' }) => {
  const [open, setOpen] = useState(false);
  const [query, setQuery] = useState('');
  const wrapRef = useRef(null);

  useEffect(() => {
    const handler = (e) => {
      if (wrapRef.current && !wrapRef.current.contains(e.target)) setOpen(false);
    };
    document.addEventListener('mousedown', handler);
    return () => document.removeEventListener('mousedown', handler);
  }, []);

  const toggle = (opt) => {
    const next = value.includes(opt) ? value.filter(v => v !== opt) : [...value, opt];
    onChange(next);
  };

  const remove = (opt, e) => {
    e.stopPropagation();
    onChange(value.filter(v => v !== opt));
  };

  const filtered = options.filter(o => o.toLowerCase().includes(query.toLowerCase()));

  return (
    <div className="chip-select-wrap" ref={wrapRef}>
      <div className="chip-box" onClick={() => setOpen(o => !o)}>
        {value.length === 0 && <span className="chip-placeholder">{placeholder}</span>}
        {value.map(v => (
          <span key={v} className="chip">
            {v}
            <span className="chip-x" onClick={e => remove(v, e)}>×</span>
          </span>
        ))}
      </div>
      {open && (
        <div className="chip-dropdown cd-open">
          <div className="cd-search">
            <input
              type="text"
              placeholder="Cauta..."
              value={query}
              onChange={e => setQuery(e.target.value)}
              onClick={e => e.stopPropagation()}
              autoFocus
            />
          </div>
          {filtered.map(opt => (
            <div
              key={opt}
              className={`cd-option${value.includes(opt) ? ' cd-selected' : ''}`}
              onClick={() => toggle(opt)}
            >
              <input type="checkbox" readOnly checked={value.includes(opt)} onClick={e => e.stopPropagation()} />
              {opt}
            </div>
          ))}
          {filtered.length === 0 && <div className="cd-option" style={{ color: 'var(--muted)' }}>Niciun rezultat</div>}
        </div>
      )}
    </div>
  );
};

export default ChipSelect;
